import ToggleWeightCost from "@/components/toggleWeightCost/toggleWeightCost.vue";
// extending Doughnut allows calling this.renderChart :)
import { Doughnut } from "vue-chartjs";
import { circleChartOptions } from "@/services/chartCustomTooltips";
import { REQUEST_STATE, STATUS_CODE } from "@/enums";
import { createNamespacedHelpers } from "vuex";
import { WasteTypeService } from "@/services/wasteTypeApi";

const { mapGetters: userGetters } = createNamespacedHelpers("user"),
	{ mapGetters: brandingGetters } = createNamespacedHelpers("branding");

export default {
	extends: Doughnut,
	components: { ToggleWeightCost },

	watch: {
		isCostToggleActive() {
			this.render();
		},
	},

	data() {
		return {
			isCostToggleActive: false,

			wasteSourceData: [],
			state: REQUEST_STATE.LOADING,
			REQUEST_STATE,

			chartData: {
				labels: [],
				datasets: [
					{
						backgroundColor: [],
						data: [],
					},
				],
			},
		};
	},

	computed: {
		...userGetters(["activeOutlet", "weightUnit"]),
		...brandingGetters(["colors"]),
		sortedWasteType,
	},

	created() {
		this.loadData();
		this.$eventBus.$on("reloadComponentData", this.loadData);
	},

	beforeDestroy() {
		this.$eventBus.$off("reloadComponentData", this.loadData);
	},

	methods: {
		loadData,
		getWasteType,
		render,
	},
};

async function loadData() {
	await this.getWasteType();
	this.render();
}

async function getWasteType() {
	try {
		this.state = REQUEST_STATE.LOADING;
		const { data } = await WasteTypeService.getWasteType();

		data.avoidable.__color = this.colors[1];
		data.avoidable.__translation_key = "filters_waste.avoidable";
		data.unavoidable.__color = "#E0E0E0";
		data.unavoidable.__translation_key = "filters_waste.unavoidable";

		this.wasteSourceData = [data.avoidable, data.unavoidable];

		this.state = REQUEST_STATE.SUCCESS;
	} catch (error) {
		if (error.response && error.response.status === STATUS_CODE.MISSING_DATA) this.state = REQUEST_STATE.MISSING_DATA;
	}
}

function sortedWasteType() {
	if (this.isCostToggleActive) return this.$utils.sortDesc(this.wasteSourceData, "cost");

	return this.$utils.sortDesc(this.wasteSourceData, "weight");
}

function render() {
	// reset chart data before appending new data
	this.chartData = {
		labels: [],
		datasets: [
			{
				backgroundColor: [],
				data: [],
			},
		],
	};

	let totalWeight = 0,
		totalCost = 0;

	this.sortedWasteType.forEach((waste) => {
		totalWeight += waste.weight;
		totalCost += waste.cost;
	});

	this.sortedWasteType.forEach((waste) => {
		const label = this.$t(waste.__translation_key),
			MAX_PERCENT = 100;

		let percentage = null;

		if (this.isCostToggleActive) percentage = (waste.cost * MAX_PERCENT) / totalCost;
		else percentage = (waste.weight * MAX_PERCENT) / totalWeight;

		this.chartData.datasets[0].data.push(percentage);
		this.chartData.datasets[0].backgroundColor.push(waste.__color);
		this.chartData.datasets[0].borderWidth = 0;
		this.chartData.labels.push(label);

		circleChartOptions.tooltips.backgroundColor.push(waste.__color);
	});

	this.renderChart(this.chartData, circleChartOptions);
}
